import React from 'react';
import { Switch, Route, Redirect } from "react-router-dom";

// ROUTING COMPONENTS
// import ProtectedRoute from "./ProtectedRoute";
import RoutesList from "./RoutesList";
import { URL_NEWS_DETAILS, URL_CHARGE_HISTORY, URL_CHARGE, URL_SUCCESS, URL_NEWS, URL_SHOP } from "Helpers/Paths";
import Home from 'Components/Home/Home';
import NewsDetails from 'Components/Pages/News/NewsDetails.jsx/NewsDetails';
import Charge from 'Components/Pages/Charge/Charge';
import Success from 'Components/Pages/Success/Success';
import News from "Components/Pages/News/NewsPage"
import PageNotFound from 'Components/PageNotFound';
import { SUPPORT_LANGUAGES } from 'Config'
const LANG_REGEX = "[a-zA-Z]{2}"

function Routes({ lang }) {
    const { REACT_APP_DOWNLOAD_URL } = process.env;
    const createRender = ( RenderComponent, redirectPath = '', path ='' )=>{
       return ({ match })=>{
            const { lang } = match.params;
            if(!lang || !SUPPORT_LANGUAGES.includes(lang.toLowerCase()) ){
                return <Redirect to={`/en${redirectPath}`} />
            }
            return  <RenderComponent />
       }
    }

    return (
        <Switch>
            {/* <Route path={URL_LOGIN} component={Login} /> */}
            <Route       exact path={`/:lang(${LANG_REGEX})?`}  render={createRender(Home)} />
            <Route       exact path={`/:lang(${LANG_REGEX})?` + URL_SHOP} render={() => window.location.replace(`${REACT_APP_DOWNLOAD_URL}/${lang}/store/pwi/list`)} />
            <Route       exact path={`/:lang(${LANG_REGEX})?` + URL_NEWS_DETAILS + "/:newsId"} render={createRender(NewsDetails, URL_NEWS, URL_NEWS_DETAILS)} />
            <Route       exact path={`/:lang(${LANG_REGEX})?` + URL_NEWS} render={createRender(News, URL_NEWS)} />
            <Route       exact path={`/:lang(${LANG_REGEX})?` + URL_CHARGE_HISTORY}  render={createRender(Charge, URL_CHARGE_HISTORY)} />
            <Route       exact path={`/:lang(${LANG_REGEX})?` + URL_CHARGE} render={createRender(Charge, URL_CHARGE)} />
            <Route       exact path={`/:lang(${LANG_REGEX})?` + URL_SUCCESS} render={createRender(Success, URL_SUCCESS)} />
            <Route       exact path="/">
                <Redirect to={`/${lang}/`} />
            </Route>
            <Route path={"*"} component={PageNotFound} />
            {
                RoutesList.map((route, index) => (
                    <Route
                        key={index}
                        path={route.path}
                        exact={route.exact}
                        component={route.component}
                    />
                ))
            }
        </Switch>
    );
}

export default Routes;
